import useDefinedContext from "hooks/useDefinedContext";
import ExercisesContextStatus from "../ExercisesContextStatus";

function useExercisesStatus() {
  return useDefinedContext(ExercisesContextStatus);
}
export default useExercisesStatus;
